/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import headerConfig from '@pages/NomineeKYCPage/config/header.config.json';
import loadingConfig from '@pages/NomineeKYCPage/config/loading.config.json';
import errorConfig from '@pages/NomineeKYCPage/config/error.config.json';
import notificationConfig from '@pages/NomineeKYCPage/config/notifications.config.json';
import editProfileConfig from '@pages/NomineeKYCPage/config/editProfile.config.json';
import bankConfig from '@pages/NomineeKYCPage/config/featuresSection.config.json';
import { vappContainer } from '@/application';
import { BreadcrumbService } from '@services/breadcrumbService';

// const getBreadcrumbService = () => {
//   return vappContainer.get<BreadcrumbService>(BreadcrumbService.displayName);
// };

export interface IStaticContentPluginMethods extends IPluginMethodMap {
  getStaticContentSync(args?: any): any;
}

export class StaticContentPlugin implements IAgentPlugin {
  readonly methods: IStaticContentPluginMethods;

  constructor() {
    this.methods = {
      getStaticContentSync: this.getStaticContentSync.bind(this),
    };
  }

  getStaticContentSync(args?: any) {
    // const srv = getBreadcrumbService();
    // const breadcrumbItems = srv?.getBreadCrumbItems();
    return {
      header: { ...headerConfig },
      loading: loadingConfig?.loading,
      error: errorConfig,
      notifications: notificationConfig,
      editProfile: editProfileConfig,
      bankConfig: bankConfig,
    };
  }
}
